export const userCacheKey = {
  ME: ['/users', '/me'],
};
